import { render, staticRenderFns } from "./FlowTemplate.vue?vue&type=template&id=54eae814&"
import script from "./FlowTemplate.vue?vue&type=script&lang=js&"
export * from "./FlowTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FlowTemplate.vue?vue&type=style&index=0&id=54eae814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports